export interface CategoryItem {
  slug: string;
  label: string;
  icon: string;
}

export interface CategoryConfig {
  id: string;
  label: string;
  tileColor: string;
  iconColor: string;
  headerIcon: string;
  connectPrompt: string;
  items: CategoryItem[];
}

export const CATEGORY_CONFIG: CategoryConfig[] = [
  {
    id: 'emergency',
    label: 'Emergency Assistance',
    tileColor: '#FFF3E0',
    iconColor: '#E65100',
    headerIcon: 'LocalFireDepartment',
    connectPrompt: 'Sudden Emergency? Connect now!',
    items: [
      { slug: 'accident-help',    label: 'Accident Help',       icon: 'LocalHospital' },
      { slug: 'roadside-assist',  label: 'Roadside Assistance', icon: 'CarRepair' },
      { slug: 'towing',           label: 'Towing Assistance',   icon: 'LocalShipping' },
      { slug: 'vehicle-lockout',  label: 'Vehicle Lockout',     icon: 'LockOpen' },
    ],
  },
  {
    id: 'legal',
    label: 'Legal & Immigration Assistance',
    tileColor: '#E3F2FD',
    iconColor: '#1565C0',
    headerIcon: 'Gavel',
    connectPrompt: 'Need legal help? Connect now!',
    items: [
      { slug: 'traffic-ticket',    label: 'Traffic Tickets',    icon: 'DirectionsCar' },
      { slug: 'legal-consult',     label: 'Legal Consultation', icon: 'Balance' },
      { slug: 'fraud-disputes',    label: 'Fraud & Disputes',   icon: 'ReportProblem' },
      { slug: 'immigration',       label: 'Immigration',        icon: 'Flight' },
    ],
  },
  {
    id: 'financial',
    label: 'Accounting & Financial Services',
    tileColor: '#E8F5E9',
    iconColor: '#2E7D32',
    headerIcon: 'AccountBalance',
    connectPrompt: 'Manage finances? Connect now!',
    items: [
      { slug: 'tax-services',      label: 'Tax Services',       icon: 'Receipt' },
      { slug: 'insurance',         label: 'Insurance',          icon: 'Security' },
      { slug: 'business-services', label: 'Business Services',  icon: 'Business' },
      { slug: 'financial-svcs',    label: 'Financial Services', icon: 'TrendingUp' },
    ],
  },
  {
    id: 'vehicle',
    label: 'Vehicle Marketplace',
    tileColor: '#EDE7F6',
    iconColor: '#4527A0',
    headerIcon: 'DirectionsCar',
    connectPrompt: 'Confused with vehicle? Connect now!',
    items: [
      { slug: 'buy-vehicle',   label: 'Buy',       icon: 'AddShoppingCart' },
      { slug: 'sell-vehicle',  label: 'Sell',      icon: 'Sell' },
      { slug: 'financing',     label: 'Financing', icon: 'CreditCard' },
      { slug: 'trade-in',      label: 'Trade-In',  icon: 'SwapHoriz' },
    ],
  },
  {
    id: 'professionals',
    label: 'Professionals Available',
    tileColor: '#FCE4EC',
    iconColor: '#880E4F',
    headerIcon: 'Groups',
    connectPrompt: 'Find a professional? Connect now!',
    items: [
      { slug: 'rcic',        label: 'RCICs',       icon: 'VerifiedUser' },
      { slug: 'lawyers',     label: 'Lawyers',     icon: 'Gavel' },
      { slug: 'accountants', label: 'Accountants', icon: 'Calculate' },
      { slug: 'paralegals',  label: 'Paralegals',  icon: 'MenuBook' },
    ],
  },
];
